import { render, staticRenderFns } from "./AssignedAudits.vue?vue&type=template&id=5710bfa1&"
import script from "./AssignedAudits.vue?vue&type=script&lang=js&"
export * from "./AssignedAudits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports